var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_30",
    "data-name": "Groupe 30",
    transform: "translate(0 -0.185)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 20,
    height: 20,
    transform: "translate(0 0.185)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_62",
    "data-name": "Trac\\xE9 62",
    d: "M24,40H40.419l-8.209,8.209Z",
    transform: "translate(-22.106 -36.866)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_31",
    "data-name": "Ligne 31",
    y2: 5,
    transform: "translate(10 11.185)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_32",
    "data-name": "Ligne 32",
    x2: 6,
    transform: "translate(7 16.185)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_33",
    "data-name": "Ligne 33",
    x2: 10,
    transform: "translate(5 6.185)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventEvent);
export default __webpack_public_path__ + "static/media/eventEvent.0728699d88c5359d0ecda4e92baf37fb.svg";
export { ForwardRef as ReactComponent };